import React, {useCallback, useEffect, useState} from "react";
import {ArrowRightIcon} from '@heroicons/react/24/solid/index.js';
import {router, useForm} from '@inertiajs/react';
import toast from 'react-hot-toast';
import {Modal} from 'react-responsive-modal';
import {useTranslation} from 'react-i18next';

const InstallPWA = ({loginLink, recaptchaKey}) => {
    const [supportsPWA, setSupportsPWA] = useState(false);
    const [promptInstall, setPromptInstall] = useState(null);
    const [open, setIsOpen] = useState(false);
    const {data, setData, post, processing, errors, setError} = useForm({
        username: '',
        token: '',
    })
    const {t} = useTranslation();
    const handleLoaded = _ => {
        window.grecaptcha.ready(_ => {
            console.log('ready');
            window.grecaptcha
                .execute(recaptchaKey, {action: "participate"})
                .then(newtoken => {
                    console.log('token ok');
                    console.log('setting recaptcha token');
                    setData('token', newtoken)
                })
        })
    }

    useEffect(() => {
        // Add reCaptcha
        const script = document.createElement("script")
        script.src = "https://www.google.com/recaptcha/api.js?render=" + recaptchaKey
        script.addEventListener("load", handleLoaded)
        document.body.appendChild(script)
    }, []);

    useEffect(() => {
        const handler = e => {
            e.preventDefault();
            console.log("we are being triggered :D");
            setSupportsPWA(true);
            setPromptInstall(e);
        };
        window.addEventListener("beforeinstallprompt", handler);

        return () => window.removeEventListener("transitionend", handler);
    }, []);

    useEffect(() => {
        console.log(errors, 'errors changed');
        if (errors.username) {
            toast.error(errors.username);
        }

        if (errors.refresh) {
            router.reload();
        }

        if (errors.error) {
            toast.error(errors.error);
        }
    }, [errors]);

    const submit = useCallback((e) => {
        e.preventDefault()

        if (!!data.username && data.username.length < 3) {
            setError('username', 'Please enter a name of at least three characters.')
            return;
        }

        post(loginLink)
    }, [data.username]);


    return (
        <>
            <Modal open={open} onClose={() => setIsOpen(false)} center>
                <div>
                    <h2 className="font-bold text-xl">{t('Join event')}</h2>
                    <p className="text-sm">{t('Please enter your full name to join this event.')}</p>

                    <form onSubmit={submit}>
                        <div className="flex flex-col mt-2">
                            <label className="font-bold" htmlFor="code">{t("Full name")}</label>
                            <input
                                value={data.email}
                                onChange={e => setData('username', e.target.value)}
                                className="rounded-[10px]"
                                type="text"
                                autoComplete="name"
                                required
                                placeholder={t("Full name")} />
                            {!!errors.username && <span className="text-xs text-red-500">{errors.username}</span>}
                            <button
                                type="submit"
                                disabled={processing}
                                className=" mt-[10px] primary-camera-button">
                                {t('Join event')} <ArrowRightIcon className="w-4 h-4 text-white-foreground ml-2" />
                            </button>
                        </div>
                    </form>
                </div>
            </Modal>

            <button
                disabled={!data.token}
                className="w-full primary-camera-button"
                onClick={() => setIsOpen(true)}
            >
                {t('Continue')} <ArrowRightIcon className="w-4 h-4 text-white-foreground ml-2" />
            </button>
        </>


    )
};

export default InstallPWA;
